import Base from './base';

class Seo extends Base {
  getAll = (query) => this.getRequest('/page-meta', query);
  getById = (id) => this.getRequest(`/page-meta/${id}`);
  create = (data) => this.postRequest('/page-meta', data);
  update = (id, data) => this.putRequest(`/page-meta/${id}`, data);
  delete = (id) => this.deleteRequest(`/page-meta/${id}`);

  getRedirects = (query) => this.getRequest('/redirect', query);
  createRedirect = (data) => this.postRequest('/redirect', data);
  updateRedirect = (id, data) => this.putRequest(`/redirect/${id}`, data);
  deleteRedirect = (id) => this.deleteRequest(`/redirect/${id}`);
  exportRedirects = () => this.getRequest('/redirect/export');

  get404Logs = (query) => this.getRequest('/404-log', query);
  delete404Log = (id) => this.deleteRequest(`/404-log/${id}`);
}

export default new Seo();
